// Mock data for CriLam Decorative Pvt. Ltd. website

export const companyInfo = {
  name: "CriLam Decorative Pvt. Ltd.",
  tagline: "India's Leading 6H Acrylic Laminated Boards & Interior Doors Manufacturer",
  phone: "8298297475",
  email: "info@crilamdecorative.com",
  whatsapp: "8298297475",
  address: "123/628 (E) Domill Street, Fazalganj, Kanpur - 208012, Uttar Pradesh, India",
  brandStatement: "CriLam Decorative Pvt. Ltd. is a Pan-India manufacturer of high-performance acrylic laminated boards and interior doors engineered for durability and consistency."
};

export const products = [
  {
    id: "acrylic-boards",
    name: "Acrylic Laminated Boards",
    tagline: "6H Hardness | Non-Yellowing | No Swelling",
    description: "6H surface hardness engineered for superior scratch resistance and zero-swelling structural stability. Our acrylic boards are manufactured using advanced lamination technology that ensures dimensional stability without pressing or re-pressing requirements.",
    features: [
      "6H surface hardness for superior durability",
      "Engineered for zero swelling and dimensional stability",
      "No pressing or re-pressing required at any stage",
      "High-gloss premium finish with scratch resistance",
      "UV-resistant formulation prevents yellowing",
      "Easy to clean and maintain with chemical resistance"
    ],
    applications: ["Modular Kitchens", "Wardrobes", "TV Units", "Office Furniture"],
    hero: "/acrylic-boards-hero.png",
    images: [
      "/modular-kitchen-app.png",
      "/wardrobe-application-new.png"
    ],
    flagship: true
  },
  {
    id: "cnc-doors",
    name: "CNC Designer Doors",
    tagline: "Precision Crafted | Custom Designs | Modern Aesthetics",
    description: "State-of-the-art CNC (Computer Numerical Control) doors manufactured with precision engineering. Our advanced CNC technology enables intricate 3D patterns, geometric designs, and custom artwork that elevate any interior space to architectural excellence.",
    features: [
      "Precision CNC cutting for intricate designs",
      "Custom patterns and personalized artwork",
      "3D textured surfaces and geometric patterns",
      "Consistent quality with computer-controlled accuracy",
      "Wide range of design options - traditional to contemporary",
      "Premium finish with smooth edges and fine detailing"
    ],
    applications: ["Main Entrance Doors", "Pooja Room Doors", "Partition Doors", "Designer Wardrobes", "Luxury Interiors"],
    hero: "/cnc-doors-hero.png",
    images: [
      "/residential-doors-app.png",
      "/hotel-hospitality-app.png"
    ]
  },
  {
    id: "wall-panels",
    name: "Decorative Wall Panels",
    tagline: "Elegant | Versatile | Easy Installation",
    description: "Premium decorative wall panels engineered for modern architectural applications. Available in multiple textures and finishes with acoustic insulation properties.",
    features: [
      "Multiple texture and finish options",
      "Rapid installation system",
      "Acoustic insulation properties",
      "Moisture-resistant composition",
      "Low-maintenance surface treatment",
      "Contemporary aesthetic design"
    ],
    applications: ["Living Rooms", "Bedrooms", "Offices", "Hotels & Restaurants"],
    hero: "/wall-paneling-app.png",
    images: [
      "/commercial-interiors-app.png",
      "/hotel-hospitality-app.png"
    ]
  },
  {
    id: "mica-doors",
    name: "Mica Laminated Doors",
    tagline: "Classic | Affordable | Reliable",
    description: "Precision-manufactured mica laminated doors offering consistent performance. Engineered for residential and light commercial applications with reliable durability.",
    features: [
      "Smooth surface finish",
      "Cost-effective manufacturing",
      "Wide range of colors and patterns",
      "Durable construction quality",
      "Easy surface maintenance",
      "Lightweight yet structurally strong"
    ],
    applications: ["Residential Doors", "Office Cabins", "Guest Rooms", "Service Areas"],
    hero: "/mica-doors-hero.png",
    images: [
      "/residential-doors-app.png",
      "/commercial-interiors-app.png"
    ]
  },
  {
    id: "veneer-doors",
    name: "Veneer Laminated Doors (Without Nail)",
    tagline: "Nail-Free Technology | Premium Finish | Natural Look",
    description: "Innovative nail-free veneer lamination technology ensures seamless doors with natural wood aesthetics. Advanced bonding process eliminates visible nails or mechanical fasteners for premium finish quality.",
    features: [
      "Nail-free lamination technology",
      "Natural wood grain appearance",
      "Seamless surface with no visible joints",
      "Premium aesthetic appeal",
      "Structurally superior strength",
      "Customizable finish options"
    ],
    applications: ["Luxury Homes", "Villas", "Premium Offices", "Hotels"],
    hero: "/veneer-doors-hero.png",
    images: [
      "/hotel-hospitality-app.png",
      "/residential-doors-app.png"
    ]
  }
];

export const whyCrilam = [
  {
    title: "In-House Lamination Facility",
    description: "State-of-the-art manufacturing setup ensuring consistent batch quality and controlled bonding technology",
    icon: "Factory"
  },
  {
    title: "6H Surface Hardness",
    description: "Industry-leading surface hardness specification for superior scratch resistance and long-term durability",
    icon: "Shield"
  },
  {
    title: "Zero Re-Pressing Technology",
    description: "Advanced lamination process eliminates pressing requirements throughout manufacturing, installation, and usage",
    icon: "Zap"
  },
  {
    title: "Pan-India Distribution",
    description: "Established supply chain network ensuring reliable product availability and timely project delivery",
    icon: "MapPin"
  },
  {
    title: "Quality Assurance Systems",
    description: "Rigorous inspection protocols and quality control measures at every manufacturing stage",
    icon: "CheckCircle"
  },
  {
    title: "Technical Support",
    description: "Expert technical guidance and comprehensive after-sales support for all product applications",
    icon: "Users"
  }
];

export const applications = [
  {
    name: "Modular Kitchens",
    description: "High-gloss acrylic boards perfect for modern kitchen cabinets and shutters",
    image: "/modular-kitchen-app.png"
  },
  {
    name: "Wardrobes",
    description: "Premium laminated boards and doors for elegant bedroom storage solutions",
    image: "/wardrobe-application-new.png"
  },
  {
    name: "Commercial Interiors",
    description: "Durable solutions for offices, hotels, and retail spaces",
    image: "/commercial-interiors-app.png"
  },
  {
    name: "Residential Doors",
    description: "Wide range of doors suitable for all rooms in modern homes",
    image: "/residential-doors-app.png"
  },
  {
    name: "Wall Paneling",
    description: "Transform walls with decorative panels for living rooms and bedrooms",
    image: "/wall-paneling-app.png"
  },
  {
    name: "Hotel & Hospitality",
    description: "Premium finishes designed for high-traffic commercial environments",
    image: "/hotel-hospitality-app.png"
  }
];

export const manufacturingProcess = [
  {
    step: "01",
    title: "Raw Material Selection",
    description: "Stringent quality standards for all raw materials ensuring consistent manufacturing output",
    image: "/raw-material-selection.png"
  },
  {
    step: "02",
    title: "Precision Lamination",
    description: "Advanced lamination technology with controlled pressure and temperature for optimal bonding",
    image: "/precision-lamination-new.png"
  },
  {
    step: "03",
    title: "Quality Inspection",
    description: "Multi-stage inspection process ensuring dimensional accuracy and surface quality standards",
    image: "/quality-inspection-new.png"
  },
  {
    step: "04",
    title: "Packaging & Dispatch",
    description: "Protective packaging system ensures damage-free transportation to destination",
    image: "/packaging-dispatch-new.png"
  }
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Interior Designer, Mumbai",
    text: "CriLam's acrylic boards are exceptional. The 6H hardness makes a real difference in kitchen projects."
  },
  {
    name: "Priya Sharma",
    role: "Dealer, Delhi",
    text: "Reliable quality and on-time delivery. My customers love the no-swelling guarantee."
  },
  {
    name: "Amit Patel",
    role: "Architect, Bangalore",
    text: "The nail-free veneer doors are a game-changer. Perfect finish every time."
  }
];
